<template>
  <nav
    class="
      right-nav
      fixed
      top-0
      bottom-0
      overflow-y-auto overflow-hidden
      shadow-xl
      bg-bg_color_1-100
      w-64
      z-65
      py-4
      px-6
      h-full
    "
    :class="active ? 'active' : 'inactive'"
  >
    <div class="flex justify-start">
      <a
        class="
          text-text_color_1-400
          block
          cursor-pointer
          px-4
          py-4
          border
          border-border_color_1-400
          rounded-lg
        "
        @click="$emit('close')"
      >
        <i class="fas fa-angle-double-right"></i>
      </a>
    </div>
    <div v-if="active" class="flex flex-col items-center">
      <form @submit.prevent="save">
        <h6 class="text-text_color_1-400 text-sm mt-3 mb-3 font-bold uppercase">
          {{ $t("events.form.label-section1") }}
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.member_card_set_code") }}
              </label>
              <input
                v-model="form.member_card_set_code"
                required
                type="text"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.code") }}
              </label>
              <input
                v-model="form.code"
                required
                type="text"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.type") }}
              </label>
              <select
                v-model="form.type"
                required
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              >
                <option value="event">
                  {{ $t("events.form.select.type.event") }}
                </option>
                <option value="package">
                  {{ $t("events.form.select.type.package") }}
                </option>
              </select>
            </div>
          </div>

          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.collect_started_at") }}
              </label>
              <datepicker
                v-model="form.collect_started_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.collect_expired_at") }}
              </label>
              <datepicker
                v-model="form.collect_expired_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("events.form.expired_at") }}
              </label>
              <datepicker
                v-model="form.expired_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
        </div>

        <div class="flex flex-wrap mt-20">
          <button
            class="
              bg-btn_green_color_active-500
              text-text_color_white
              active:bg-btn_green_color_active-600
              font-bold
              uppercase
              text-xs
              px-4
              py-2
              rounded
              shadow
              hover:shadow-md
              outline-none
              focus:outline-none
              mr-1
              ease-linear
              transition-all
              duration-150
            "
            type="submit"
          >
            <i class="fas fa-save"></i> {{ $t("app.button.save") }}
          </button>
          <button
            v-if="model"
            class="
              bg-btn_gray_color_active-50
              text-text_color_1-600
              active:bg-btn_gray_color_active-200
              uppercase
              text-xs
              px-4
              py-2
              rounded
              shadow
              hover:shadow-md
              outline-none
              focus:outline-none
              mr-1
              ease-linear
              transition-all
              duration-150
            "
            @click.prevent="reset"
          >
            <i class="fas fa-undo-alt"></i> {{ $t("app.button.reset") }}
          </button>
        </div>
      </form>
    </div>
  </nav>
</template>
); }

<script>
import Datepicker from "vue3-datepicker";

export default {
  data() {
    return {
      form: {},
      today: new Date(),
    };
  },
  emits: ["close", "onSubmitUpdate", "onSubmitCreate"],
  components: {
    Datepicker,
  },
  props: {
    active: {
      default: false,
    },
    model: {
      default: null,
    },
  },
  methods: {
    save() {
      if (this.model) {
        this.$emit("onSubmitUpdate", {
          ...this.form,
          expired_at: this.$moment(this.form.expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_started_at: this.$moment(this.form.collect_started_at_fmt)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .format(),
          collect_expired_at: this.$moment(this.form.collect_expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
        });
      } else {
        this.$emit("onSubmitCreate", {
          ...this.form,
          expired_at: this.$moment(this.form.expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_started_at: this.$moment(this.form.collect_started_at_fmt)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .format(),
          collect_expired_at: this.$moment(this.form.collect_expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
        });
      }
      if (this.model) {
        this.form = {
          ...this.model,
          expired_at_fmt: new Date(this.model.expired_at || this.today),
          collect_expired_at_fmt: new Date(
            this.model.collect_expired_at || this.today
          ),
          collect_started_at_fmt: new Date(
            this.model.collect_started_at || this.today
          ),
        };
      } else {
        this.form = {};
      }
      this.$emit("close");
    },
    reset() {
      let confirmed = window.confirm(`${this.$t("app.confirm-reset")}`);
      if (confirmed) {
        if (this.model) {
          this.form = {
            ...this.model,
            expired_at_fmt: new Date(this.model.expired_at || this.today),
          collect_expired_at_fmt: new Date(
            this.model.collect_expired_at || this.today
          ),
          collect_started_at_fmt: new Date(
            this.model.collect_started_at || this.today
          ),
          };
        } else {
          this.form = {};
        }
      }
    },
  },
  watch: {
    model(val) {
      if (val) {
        this.form =
          {
            ...val,
            expired_at_fmt: new Date(val.expired_at || this.today),
            collect_expired_at_fmt: new Date(val.collect_expired_at || this.today),
            collect_started_at_fmt: new Date(val.collect_started_at || this.today),
          } || {};
      } else {
        this.form = {};
      }
    },
  },
};
</script>

<style scoped>
.right-nav {
  left: auto;
  right: 0;
  width: 50%;
  max-width: 50%;
}

@media (max-width: 768px) {
  .right-nav {
    left: auto;
    right: 0;
    width: 100%;
    max-width: 100%;
  }
}

.active {
  transform: translatex(0);
  transition: all 0.2s ease-out;
}

.inactive {
  transform: translatex(100%);
  transition: all 0.2s ease-out;
}
</style>